import React from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import TestimonialCard from '../components/TestimonialCard';

const FEATURES = [
  {
    title: 'Up to 50% off',
    text: "Join a shared license pool and split the cost of a genuine multi-seat plan with other buyers — same software, half the price.",
    icon: '₦'
  },
  {
    title: 'Delivered by email',
    text: 'Your license key lands in your inbox within minutes of payment confirmation — no waiting, no manual approval.',
    icon: '✉'
  },
  {
    title: '100% genuine licenses',
    text: 'Every key is sourced and activated the way the software vendor intends. Nothing pirated, nothing cracked.',
    icon: '✓'
  },
  {
    title: 'Local payment options',
    text: 'Pay by card, bank transfer or USSD through Paystack or Squad by GTCO — no foreign card needed.',
    icon: '⚡'
  }
];

class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { featuredProducts: [], testimonials: [], loading: true };
  }

  componentDidMount() {
    Promise.all([api.getProducts(), api.getAllTestimonials()])
      .then(([products, testimonials]) => {
        const featured = products.filter((p) => p.is_featured);
        this.setState({
          featuredProducts: (featured.length ? featured : products).slice(0, 6),
          testimonials,
          loading: false
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const { featuredProducts, testimonials } = this.state;
    return (
      <div className="landing">
        <section className="hero">
          <div className="hero-inner">
            <span className="eyebrow">Trusted by teams across Nigeria</span>
            <h1>Genuine software licenses. Up to 50% less with shared plans.</h1>
            <p>
              Buy a private license or split the cost with a shared license pool —
              same authentic software, a fraction of the price, delivered straight
              to your inbox.
            </p>
            <div className="hero-actions">
              <Link to="/products" className="btn btn-primary btn-lg">Browse licenses</Link>
              <Link to="/about" className="btn btn-ghost btn-lg">How shared licensing works</Link>
            </div>
          </div>
        </section>

        <section className="features">
          <div className="feature-grid">
            {FEATURES.map((f) => (
              <div key={f.title} className="feature-card">
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="featured">
          <div className="section-heading">
            <h2>Popular licenses</h2>
            <Link to="/products" className="see-all">See all &rarr;</Link>
          </div>
          <div className="product-grid">
            {featuredProducts.map((p) => (
              <div key={p.id} className="product-card">
                <img src={p.image_url} alt={p.name} />
                <h3>{p.name}</h3>
                <p className="vendor">{p.vendor}</p>
                <div className="price-row">
                  <span className="price-shared">₦{Number(p.shared_price).toLocaleString()} shared</span>
                  <span className="price-full">₦{Number(p.full_price).toLocaleString()} private</span>
                </div>
                <Link to={`/products/${p.id}`} className="btn">View details</Link>
              </div>
            ))}
          </div>
        </section>

        <section className="testimonials">
          <div className="section-heading center">
            <h2>What our customers say</h2>
            <p className="section-sub">Real feedback on pricing, discounts and license authenticity.</p>
          </div>
          <div className="testimonial-grid">
            {testimonials.map((t, idx) => (
              <TestimonialCard key={idx} testimonial={t} />
            ))}
            {testimonials.length === 0 && <p>No testimonials yet — be the first to leave one.</p>}
          </div>
        </section>

        <section className="cta-band">
          <h2>Ready to stop paying full price?</h2>
          <p>Browse the catalog and see how much a shared license saves you today.</p>
          <Link to="/products" className="btn btn-primary btn-lg">Browse licenses</Link>
        </section>
      </div>
    );
  }
}

export default LandingPage;
